export const checkSentryDSN = (dsn) => !!dsn && dsn.length > 0;
//# sourceMappingURL=utils.js.map